import type { APIClient } from '@src/shared/api';

import { useMutation } from '@src/shared/query';

export type LanguageChangePayload = {
  language: string;
};

type LanguageChangeResponse = {
  detail: string;
  language: string;
};

export function useLanguageChange() {
  return useMutation<LanguageChangeResponse, Error, LanguageChangePayload>({
    mutationKey: ['auth', 'language-change'],
    mutateFn: ({ apiClient, ...payload }: { apiClient: APIClient } & Record<string, unknown>) => {
      return apiClient.request({
        url: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/language/change/`,
        method: 'POST',
        payload,
      }) as Promise<LanguageChangeResponse>;
    },
  });
}
